import { render, staticRenderFns } from "./typesetting1.vue?vue&type=template&id=3892c81d&scoped=true&"
import script from "./typesetting1.vue?vue&type=script&lang=js&"
export * from "./typesetting1.vue?vue&type=script&lang=js&"
import style0 from "./typesetting1.vue?vue&type=style&index=0&id=3892c81d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892c81d",
  null
  
)

export default component.exports